import { tableAnatomy as parts } from '@chakra-ui/anatomy'

const baseStyle = {
  table: {
    fontVariantNumeric: 'lining-nums tabular-nums',
    borderCollapse: 'collapse',
    borderTopWidth: '1px',
    width: 'full'
  },
  thead: {
    bg: 'brand.front'
  },
  tbody: {
    width: '100%'
  },
  tfoot: {
    'th, td': {
      fontSize: 'sm'
    }
  },
  th: {
    position: 'relative',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'xs',
    textTransform: 'initial',
    letterSpacing: 'normal',
    textAlign: 'start',
    whiteSpace: 'nowrap',
    bg: 'brand.hover',
    '&:last-child': {
      textAlign: 'end'
    }
  },
  td: {
    textAlign: 'start',
    '&:last-child': {
      textAlign: 'end'
    }
  },
  caption: {
    mt: 4,
    fontFamily: 'heading',
    textAlign: 'center',
    fontWeight: 'medium'
  }
}

const numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
}
const positionStyles = {
  '&[data-position="center"]': {
    textAlign: 'center'
  },
  '&[data-position="start"]': {
    textAlign: 'left'
  },
  '&[data-position="end"]': {
    textAlign: 'right'
  }
}

const variantSimple = {
  th: {
    color: 'brand.muted',
    borderBottomWidth: '1px',
    borderColor: 'brand.border',
    ...numericStyles,
    ...positionStyles
  },
  td: {
    borderBottom: '1px',
    borderColor: 'brand.border',
    ...numericStyles,
    ...positionStyles
  },
  caption: {
    color: 'brand.muted'
  },
  tbody: {
    tr: {
      '&:last-of-type': {
        td: {
          borderBottomWidth: 0
        }
      },
      _hover: {
        bg: 'brand.row'
      }
    }
  },
  tfoot: {
    tr: {
      '&:first-of-type': {
        'th, td': {
          borderTopWidth: '1px'
        }
      },
      '&:last-of-type': {
        'th, td': {
          borderBottomWidth: '1px'
        }
      }
    }
  }
}

const variantStripe = {
  ...variantSimple,
  tr: {
    ...variantSimple.tr,
    '&:nth-of-type(odd)': {
      td: {
        bg: 'brand.row'
      }
    }
  }
}

const variants = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: {}
}

const sizes = {
  xs: {
    th: {
      px: '1',
      py: '2',
      lineHeight: '1',
      '&:first-of-type': {
        pl: '4'
      },
      '&:last-child': {
        pr: '4'
      }
    },
    td: {
      px: '1',
      py: '2',
      fontSize: 'sm',
      lineHeight: '1',
      '&:first-of-type': {
        pl: '4'
      },
      '&:last-child': {
        pr: '4'
      }
    },
    caption: {
      px: '2',
      py: '1',
      fontSize: 'xs'
    }
  },
  sm: {
    th: {
      px: '2',
      py: '3',
      lineHeight: '4',
      '&:first-of-type': {
        pl: '4'
      },
      '&:last-child': {
        pr: '4'
      }
    },
    td: {
      p: '2',
      fontSize: 'sm',
      lineHeight: '4',
      '&:first-of-type': {
        pl: '4'
      },
      '&:last-child': {
        pr: '4'
      }
    },
    caption: {
      px: '4',
      py: '2',
      fontSize: 'xs'
    }
  },
  md: {
    th: {
      p: '4',
      lineHeight: '4',
      '&:first-of-type': {
        pl: '6'
      },
      '&:last-child': {
        pr: '6'
      }
    },
    td: {
      p: '4',
      lineHeight: '5',
      '&:first-of-type': {
        pl: '6'
      },
      '&:last-child': {
        pr: '6'
      }
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'sm'
    }
  },
  lg: {
    th: {
      p: '4',
      lineHeight: '5',
      fontSize: 'sm',
      '&:first-of-type': {
        pl: '8'
      },
      '&:last-child': {
        pr: '8'
      }
    },
    td: {
      p: '4',
      lineHeight: '6',
      '&:first-of-type': {
        pl: '8'
      },
      '&:last-child': {
        pr: '8'
      }
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'md'
    }
  }
}

const defaultProps = {
  variant: 'simple',
  size: 'sm'
}

export const Table = {
  parts: parts.keys,
  baseStyle,
  variants,
  sizes,
  defaultProps
}
